import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {environment} from '../../../../../environments/environment';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import Swiper from 'swiper/bundle';

@Component({
  selector: 'app-image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.scss']
})
export class ImagePreviewComponent implements OnInit {

  images: [];

  activeIndex: number = 1;

  SERVER_URL = environment.SERVER_URL;

  constructor(
    private cdr: ChangeDetectorRef,
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.images = this.data.images;
  }

  cancel() {
    this.dialogRef.close();
  }

  onActiveIndexChange(swiper: Swiper) {
    this.activeIndex = swiper.activeIndex + 1;
    this.cdr.detectChanges();

  }
}
